export const CIDES_LOGO =
  "https://customer-assets.emergentagent.com/job_revenue-assurance/artifacts/uw81nunv_logo_cides_transparent.png";

export const IMG = {
  heroBg: "https://images.unsplash.com/photo-1644088379091-d574269d422f?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  telecomTower: "https://images.unsplash.com/photo-1758473788048-eda14371fe74?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  revenue: "https://images.pexels.com/photos/10325707/pexels-photo-10325707.png",
  securityDocs: "https://images.pexels.com/photos/37730212/pexels-photo-37730212.jpeg",
};
